import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Link, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import * as React from 'react';
import { toast } from 'react-toastify';
import { useObservable } from 'react-use-observable';
import { useSaveTerms } from 'v2/hooks/useSaveTerms';
import eduzzAccountsService from 'v2/services/eduzzAccount';

export const ModalTerms = () => {
  const [user] = useObservable(() => eduzzAccountsService.getUser(), []);
  const [accesses] = useObservable(() => eduzzAccountsService.getAccesses(), []);
  const [isOpen, setIsOpen] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);

  const saveAcceptTermsMutation = useSaveTerms({
    onSuccess: () => {
      toast.success('Aceite dos termos salvo com sucesso');
      setIsOpen(false);
    },
    onError: () => {
      toast.error('Erro ao aceitar os termos');
      setIsLoading(false);
    },
  });

  const saveRefuseTermosMutation = useSaveTerms({
    onSettled: () => {
      eduzzAccountsService.logout();
    },
  });

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  React.useEffect(() => {
    if (!user || user.is_support || !accesses) return;
    const canApproveNewTerms = (accesses ?? []).some((item) => item.id === user?.id && item.isMe === true && item.termsAcceptance == false);
    setIsOpen(canApproveNewTerms);
  }, [user, accesses]);

  const handleRefuse = async () => {
    setIsLoading(true);
    await saveRefuseTermosMutation.mutateAsync(false);
  };

  const handleAccept = async () => {
    setIsLoading(true);
    await saveAcceptTermsMutation.mutateAsync(true);
  };

  return (
    <Dialog open={isOpen} style={{ zIndex: 2000 }} fullScreen={isMobile} disableEscapeKeyDown maxWidth='md'>
      <DialogTitle>Atualizamos nossos Termos de Uso</DialogTitle>
      <DialogContent>
        <DialogContentText>
          <Typography>
            Estamos atualizando nossos Termos de Uso e, para continuar utilizando nossos serviços, a partir desta data você deve concordar com estas
            revisões.
          </Typography>
          <Link
            href='https://eduzz.com/termos'
            underline='none'
            target='_blank'
            rel='noopener noreferrer'
            style={{ display: 'flex', margin: '20px', justifyContent: 'center' }}
          >
            Novos Termos de Uso da Eduzz
          </Link>
          <Typography>Em caso de dúvidas entre em contato com o nosso Canal de Atendimento em:</Typography>
          <Link href='mailto:suporte@eduzz.com' underline='none' style={{ display: 'flex', margin: '16px', justifyContent: 'center' }}>
            suporte@eduzz.com
          </Link>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button disabled={isLoading} onClick={handleRefuse}>
          Recusar e sair
        </Button>
        <Button variant='contained' disabled={isLoading} onClick={handleAccept}>
          Aceitar e prosseguir
        </Button>
      </DialogActions>
    </Dialog>
  );
};
